import * as constantsModule from '../variables/constants'

const constants = { ...constantsModule }
/**
 * Material UI Theme Overrides
 */
export const overrides = {
  constants,
  overrides: {
    MuiTab: {
      root: {
        textTransform: 'uppercase',
        '@media (min-width: 960px)': {
          minWidth: 100
        }
      }
    }
  },
  palette: {
    type: 'light',
    textImageFilter: 'none',
    text: {
      primaryDark: '#153a59',
      primaryLight: '#1d8fb9',
      altDark: 'rgba(0, 0, 0, 0.54)',
      map: '#444'
    },
    background: {
      default: '#f5f5f5',
      lightBlue: '#e9f4f8',
      lightest: '#eaecef',
      light: 'rgba(225, 224, 224, 0.25)',
      road: '#ccc',
      water: '#92b9f6'
    }
  }
}

export default overrides
